<template>
  <el-drawer
    v-model="drawer"
    :direction="direction"
    :before-close="handleClose"
    :with-header="false"
    destroy-on-close
  >
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="语音识别" name="recognition">
        <recognition></recognition>
      </el-tab-pane>
    </el-tabs>
  </el-drawer>
</template>

<script>
import Recognition from "@/components/Drawers/Live/Recognition";

export default {
  name: "MyDrawer",
  components: {
    Recognition
  },
  props: {
    drawer: {
      type: Boolean,
      default: false,
    }
  },
  emits: ["closeDrawer"],
  data() {
    return {
      direction: "rtl",
      activeName: "recognition",

    };
  },
  methods: {
    handleClose() {
      this.$emit("closeDrawer");
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
  }
};
</script>

<style scoped lang="scss">
.el-drawer {
  color: blue;
}


::v-deep {
  .el-tabs__nav {
    width: 100%;

    height: 44px;
    border: 1px solid #CCCCCC !important;
    border-radius: 10px !important;
  }

  .el-tabs__header {
    text-align: center;
    height: 44px;
    border: none;
    margin-bottom: 35px;

    .el-tabs__item {
      width: 100%;
      height: 44px;
      font-size: 18px;
      color: #333333;
    }

    .el-tabs__item.is-active {
      background: #2AA5E3;
      color: #FBFBFB;
    }

    .el-tabs__item.is-active:first-child {
      border-radius: 10px 0 0 10px;
    }

    .el-tabs__item.is-active:last-child {
      border-radius: 0 10px 10px 0;
    }
  }
}
</style>
